import { useTranslation } from 'react-i18next';
import { Button } from '../../UI/base/Button';
import styles from './WeekEmptyState.module.css';

interface WeekEmptyStateProps {
  onGoToCurrentWeek: () => void;
}

export const WeekEmptyState = ({ onGoToCurrentWeek }: WeekEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyState}>
      <div className={styles.calendarGlyph} aria-hidden="true">
        <span className={styles.calendarGlyphTop} />
        <span className={styles.calendarGlyphBody} />
      </div>
      <h2 className={styles.title}>{t('week-overview-unplanned-title')}</h2>
      <p className={styles.description}>{t('week-overview-unplanned-description')}</p>
      <Button type="secondary" onClick={onGoToCurrentWeek}>
        {t('week-overview-today')}
      </Button>
    </div>
  );
};
